// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3_JN2","main":"styles__main___g09al","carousel":"styles__carousel___3palj","card":"styles__card___1HCk4","paging":"styles__paging___1ry82"};